import React, { Component } from 'react'; //different
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';

class App extends Component {

     componentDidMount() {
        ////console.log(23565);
        this.logout();
    }
    
    validateLogout = (e) => {
        localStorage.removeItem('auth_token', '')
        localStorage.removeItem('cookie', '')
        this.setState({
            userid: null,
            username: null,
            password: null,
            firstname: null,
            lastname: null,
            point: null,
            loginstate: false,
        });
    }

logout = (e) => {
    // e.preventDefault(); // ถ้าเรียกจาก form ให้ uncomment
    const errors = this.validateLogout();

    // redirect URL แบบเต็ม
    const logoutUrl = 'https://www.UFA11.com';

    if (errors === true) {
        // ถ้าไม่มี error
        window.location.href = logoutUrl;
    } else {
        // ถ้ามี error
        this.setState({
            errors: errors,
            formSubmitted: true
        });
        // ยัง redirect ไป logoutUrl
        window.location.href = logoutUrl;
    }
}
    render() {
        return (
            <nav className="x-header navbar navbar-expand-lg -anon">
             
            </nav>


        );
    }
}
export default App;
